import React, { useEffect, lazy, Suspense, useState } from 'react';
import { Element } from 'react-scroll';

import '../assets/css/base.css';
import '../assets/css/main.css';
import '../assets/css/vendor.css';
import { ReactComponent as ReactLogo } from '../assets/images/logo.svg';

const Intro = lazy(() => import('./Intro'));
const About = lazy(() => import('./About'));
const Contact = lazy(() => import('./Contact'));
const Footer = lazy(() => import('./Footer'));
const Portfolio = lazy(() => import('./Portfolio'));


function Main() {
  const [progress, setProgress] = useState(true);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      setProgress(false);
      document.body.style.overflow = 'unset';
    }, 1000);
  }, []);

  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      });
    });
  }, [])

  return (
    <Element name="top">
      {/* <div id="top"> */}
      {!progress && <Suspense fallback={<div>Loading...</div>}>
        <Intro />
        <About />
        <Portfolio />
        <Contact />
        <Footer />
      </Suspense>}

      {progress && <div id="preloader">
        <div className='progress-bar' />
        <ReactLogo id="loader" />
      </div>}
      {/* </div> */}
    </Element>
  )
}

export default Main;